import { render } from "./ModalItem.vue?vue&type=template&id=c9954442"
import script from "./ModalItem.vue?vue&type=script&lang=js"
export * from "./ModalItem.vue?vue&type=script&lang=js"

import "./ModalItem.vue?vue&type=style&index=0&id=c9954442&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__